import { render, staticRenderFns } from "./change-enterprise-menu.vue?vue&type=template&id=8f2e773c"
import script from "./change-enterprise-menu.vue?vue&type=script&lang=js"
export * from "./change-enterprise-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports